module.exports = __webpack_public_path__ + "img/fridge_open.ae9e92ed.png";